import { Component, Inject, OnInit } from '@angular/core';
import { DialogConfig, DialogConfigData } from '@app/common/models/dialog-config';
import { DialogRef } from '@app/common/services/dialog-ref';
import { OpinionRequestModel } from '@app/ps/models/opinion-request.model';
import { UploadFileExtended } from '@app/common/components/fileupload/fileupload.component';
import { PricingExpertOpinionBaseComponent } from '@app/ps/titles/components/pricing-expert-opinion-base/pricing-expert-opinion-base.component';
import { ListModel } from '@app/common/models/list.model';
import { DocumentModel } from '@app/common/models/document.model';
import { AttachmentTypeModel } from '@app/common/models/attachment-type.model';
import { AuthService } from '@app/common/services/auth.service';
import { UploadService } from '@app/common/services/upload.service';
import {Restangular} from "ngx-restangular";

@Component({
  selector: 'simple-text-modal',
  templateUrl: './pricing-expert-opinion-change-document-dialog.component.html',
})
export class PricingExpertOpinionChangeDocumentDialogComponent implements OnInit {

  opinionRequest: OpinionRequestModel;
  filesMsg = PricingExpertOpinionBaseComponent.MSG_FILES_DEFAULT;
  filesValid = false;
  files: UploadFileExtended[];
  loading = false;
  documentList: ListModel<DocumentModel>;
  attachmentType = AttachmentTypeModel.createById('OPINION_SCAN');

  constructor(
    private authService: AuthService,
    private dialogConfig: DialogConfig,
    public dialogComponent: DialogRef,
    private uploadService: UploadService,
    private restangular: Restangular,
  ) {
    this.onUpdate = this.onUpdate.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  ngOnInit() {
    this.opinionRequest = (<DialogConfigData>this.dialogConfig.data).opinionRequest;
    this.documentList = (<DialogConfigData>this.dialogConfig.data).documentList;
  }

  onFileChange(files: UploadFileExtended[]) {
    this.files = files;
    const extensionValid = files.every(f => f.extension && f.extension.toLowerCase() === 'pdf');

    if (this.files.length === 0) {
      this.filesMsg = PricingExpertOpinionBaseComponent.MSG_FILES_DEFAULT;
    } else if (!extensionValid) {
      this.filesMsg = PricingExpertOpinionBaseComponent.MSG_FILES_EXTENSION;
    } else if (this.files.length > 1) {
      this.filesMsg = PricingExpertOpinionBaseComponent.MSG_FILES_QUANTITY;
    } else {
      this.filesMsg = '';
    }

    this.filesValid = (extensionValid && this.files.length === 1);
  }

  async onUpdate() {
    this.loading = true;

    // smazani predchozich
    for (const document of this.documentList.list) {
      if (document.sourceType === 'MPV') {
        for (const component of document.components) {
          if (component.attachmentType === 'OPINION_SCAN' && !component.cancelled) {
            await this.restangular.one('documents', component.document.id)
              .one('components', component.id)
              .customPOST({}, 'cancel')
              .toPromise();
          }
        }
      }
    }

    // zalozeni noveho
    const sendData = {
      file: this.files[0].fileEntry,
      filename: this.files[0].fileEntry.name,
      attachmentType: this.attachmentType.id,
      opinionRequestId: this.opinionRequest.id
    };

    await this.uploadService.upload({
      url: this.authService.getActiveApplicationRestUrl() + '/documents/components/upload',
      data: sendData,
      headers: { Authorization: this.authService.getToken() }
    }).progress(event => {
      this.files[0].progress = (100.0 * event.loaded / event.total);
    }).success(() => {
      this.files.splice(0, this.files.length);
    }).error(() => {
      this.files[0].error = true;
    });

    this.dialogComponent.close(true);
  }

  onCancel() {
    this.dialogComponent.close(false);
  }
}
